import React from 'react';
import {withCommas} from 'shared/utils';

interface Props {
  value: number;
  subtext?: string;
  label?: string;
  children?: React.ReactNode;
}

const LabeledHorizontalPlotContainer = ({children, value, subtext, label}: Props) => (
  <div className="about-college-score-range" aria-hidden="true">
    <div className="about-college-score-plot">{children}</div>
    <div className="college-score-range-label">
      <div>{label || `$${withCommas(Math.round(value))}`}</div>
      <div className="college-score-range-label-subtext">{subtext}</div>
    </div>
  </div>
);

export default LabeledHorizontalPlotContainer;
